.skeleton {
  display: inline-block;
  border-radius: var(--radius-sm);
  background: linear-gradient(
    90deg,
    var(--color-elevated) 0%,
    var(--color-hover) 50%,
    var(--color-elevated) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
}

.skeleton--circle {
  border-radius: var(--radius-full);
}

.skeleton-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

@keyframes skeleton-shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
    background: var(--color-elevated);
  }
}
